import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.deploy;

const deployData = createSelector([selector], (state) => state);

export default {
  deployData
};
